import { cn } from "@/lib/cn";
import { formatPrice } from "@/lib/format";

export function Price({
  cents,
  regularCents,
  size = "md",
  className,
}: {
  cents: number;
  regularCents?: number; // when present and greater, shows a struck-through regular price
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}) {
  const onSale = typeof regularCents === "number" && regularCents > cents;
  const sizes = {
    sm: "text-sm",
    md: "text-lg",
    lg: "text-2xl",
    xl: "text-3xl",
  } as const;

  return (
    <span className={cn("inline-flex items-baseline gap-2", className)}>
      <span
        className={cn("font-condensed font-bold text-night-blue", sizes[size])}
      >
        {formatPrice(cents)}
      </span>
      {onSale && (
        <span className="text-sm font-medium text-night-blue/70 line-through">
          {formatPrice(regularCents!)}
        </span>
      )}
    </span>
  );
}
